import styled from 'styled-components';

export const StyledPlaySimpleSaleBadge = styled.div`
    position: absolute;
    z-index: 1;
    top: -13px;
    right: -13px;
    width: 64px;
    height: 64px;
    background: ${(props: any) =>
        props.backgroundSrc ? `url("${props.backgroundSrc}")` : 'none'};
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .playSimple__sale-badge {
        &__number {
            color: #ffffff;
            font-size: 14px;
            font-weight: 600;
        }

        &__text {
            color: white;
            font-size: 12px;
        }
    }
` as any;
